import { Component, HostListener } from '@angular/core';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [SidebarComponent, NavbarComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  isSidebarToggled: boolean = false;
  isMobileScreen: boolean = false;
  isMobileSideNav: boolean = false;
  constructor() {
    this.checkScreenSize();
  }
  ngOnInit() {
    const savedState = localStorage.getItem('isToggled');
    this.isSidebarToggled = savedState === 'true';
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }
  checkScreenSize() {
    this.isMobileScreen = window.innerWidth < 640;
  }
  handleMobileSideNav=(value: any)=>{
    this.isMobileSideNav = value;
    console.log('dashboard', this.isMobileSideNav)
  }

  handleToggle(value: boolean) {
    this.isSidebarToggled = value;
  }
}
